"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitiveProfileAccountsV5Client = void 0;
const types_accounts_hub_1 = require("@journeyapps-platform/types-accounts-hub");
const _1 = require(".");
/**
 * A client which performs actions once the user has elevated their session by reauthenticating
 */
class SensitiveProfileAccountsV5Client extends _1.AccountsV5Client {
    constructor() {
        super(...arguments);
        this.registerTOTPUserMFAFactor = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.REGISTER_TOTP_USER_MFA_FACTOR
        });
        this.registerSMSUserMFAFactor = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.REGISTER_SMS_USER_MFA_FACTOR
        });
        this.setPreferredMFAMethod = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.SET_PREFERRED_MFA_METHOD
        });
        this.deleteMFAFactor = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.DELETE_MFA_FACTOR
        });
        this.verifyMFAFactor = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.VERIFY_MFA_FACTOR
        });
        this.generateMFABackupCodes = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GENERATE_MFA_BACKUP_CODES
        });
    }
}
exports.SensitiveProfileAccountsV5Client = SensitiveProfileAccountsV5Client;
